
import Vue from 'vue'
import { RCheckbox, RIcon } from '@/components/'
import Datepicker from 'vue-ctk-date-time-picker'
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css'
import { WorkstationDocument } from '@/api/types/workstation'
import { mapGetters } from 'vuex'

export default Vue.extend({
  name: 'ResourcesTree',
  components: {
    RCheckbox,
    Datepicker,
    RIcon,
  },
  data() {
    return {
      range: null,
    }
  },
  props: {
    selected: {
      type: Object, // TODO as PropType<...>
      required: true,
    },
    user: {
      type: Object, // TODO as PropType<...>
      required: true,
    },
  },
  computed: {
    ...mapGetters(['theme']),
    workplaceName(): string {
      return this.user ? this.user.finalDisplayName : ''
    },
    workstations(): Array<WorkstationDocument> {
      return this.user ? this.user.workstations : []
    },
    allSelected(): boolean {
      for (const w of this.workstations) {
        if (!this.selectedItem(w.uuid)) {
          return false
        }
      }
      return true
    },
  },
  methods: {
    selectAll() {
      for (const w of this.workstations) {
        Vue.set(this.selected, w.uuid, true)
      }
    },
    deselectAll() {
      for (const w of this.workstations) {
        Vue.set(this.selected, w.uuid, false)
      }
    },
    toggle(uuid: string) {
      Vue.set(this.selected, uuid, !this.selectedItem(uuid))
    },
    selectedItem(uuid: string): boolean {
      return this.selected[uuid] !== false // undefined treated as a default: true
    },
  },
  watch: {
    range() {
      this.$emit('input', this.range)
    },
  },
})
